"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleLoader = void 0;
var js_api_loader_1 = require("@googlemaps/js-api-loader");
var API_KEY = 'AIzaSyARMAWiwgcXBZaACKO57HF_r9bAO0zhh58';
exports.googleLoader = new js_api_loader_1.Loader({
    apiKey: API_KEY,
    version: 'weekly',
});
//# sourceMappingURL=GoogleLoader.js.map